import { render, staticRenderFns } from "./CarrinhaEmpresaFinalizarDetalhesPagamento.vue?vue&type=template&id=b04ecbb0"
import script from "./CarrinhaEmpresaFinalizarDetalhesPagamento.vue?vue&type=script&lang=js"
export * from "./CarrinhaEmpresaFinalizarDetalhesPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports